import TopPageSlider from '@js/modules/embla/top';
new TopPageSlider().attachEvent();
